export var RoulettePocket;
(function (RoulettePocket) {
    RoulettePocket["POCKET_00"] = "00";
    RoulettePocket["POCKET_0"] = "0";
    RoulettePocket["POCKET_1"] = "1";
    RoulettePocket["POCKET_2"] = "2";
    RoulettePocket["POCKET_3"] = "3";
    RoulettePocket["POCKET_4"] = "4";
    RoulettePocket["POCKET_5"] = "5";
    RoulettePocket["POCKET_6"] = "6";
    RoulettePocket["POCKET_7"] = "7";
    RoulettePocket["POCKET_8"] = "8";
    RoulettePocket["POCKET_9"] = "9";
    RoulettePocket["POCKET_10"] = "10";
    RoulettePocket["POCKET_11"] = "11";
    RoulettePocket["POCKET_12"] = "12";
    RoulettePocket["POCKET_13"] = "13";
    RoulettePocket["POCKET_14"] = "14";
    RoulettePocket["POCKET_15"] = "15";
    RoulettePocket["POCKET_16"] = "16";
    RoulettePocket["POCKET_17"] = "17";
    RoulettePocket["POCKET_18"] = "18";
    RoulettePocket["POCKET_19"] = "19";
    RoulettePocket["POCKET_20"] = "20";
    RoulettePocket["POCKET_21"] = "21";
    RoulettePocket["POCKET_22"] = "22";
    RoulettePocket["POCKET_23"] = "23";
    RoulettePocket["POCKET_24"] = "24";
    RoulettePocket["POCKET_25"] = "25";
    RoulettePocket["POCKET_26"] = "26";
    RoulettePocket["POCKET_27"] = "27";
    RoulettePocket["POCKET_28"] = "28";
    RoulettePocket["POCKET_29"] = "29";
    RoulettePocket["POCKET_30"] = "30";
    RoulettePocket["POCKET_31"] = "31";
    RoulettePocket["POCKET_32"] = "32";
    RoulettePocket["POCKET_33"] = "33";
    RoulettePocket["POCKET_34"] = "34";
    RoulettePocket["POCKET_35"] = "35";
    RoulettePocket["POCKET_36"] = "36";
})(RoulettePocket || (RoulettePocket = {}));
